import { useEffect } from 'react';
import { useAppDispatch } from '../redux/hooks';
import { setSelectedPeriod } from '../redux/slices/periods/periodsSlice';
import { Period } from '../interfaces/Periods';

export const useEnsureValidPeriod = (periods: Period[] | null | undefined, lastPeriod: Period | null | undefined) => {
    const dispatch = useAppDispatch();

    useEffect(() => {
        if (!periods || !periods.length) return;

        const validPeriods = periods.filter((p: Period) => p.estado === 1);
        const lastActivePeriod = validPeriods.at(-1);

        if (!lastActivePeriod) return;

        const isValid = periods.some((p: Period) => p.value.replace('Período ', '') === lastPeriod?.value);

        if (!isValid) {
            dispatch(setSelectedPeriod({ period: lastActivePeriod.value.replace('Período ', '') }));
        }
    }, [periods]);
};
